import MomentUtils from '@date-io/moment';
import { Box, ButtonBase, InputAdornment, TextField } from '@material-ui/core';
import {
  DatePicker,
  DateTimePicker,
  TimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import React from 'react';
import moment from 'moment';
import DynamicIcon from 'components/Common/DynamicIcon';

const DateInputCell = React.memo(
  ({ row, column, rowState, handleRowChange }) => {
    const timePickerRef = React.useRef({});

    React.useEffect(() => {
      handleRowChange(row.id, {
        [column.key]:
          (rowState || {})[column.key] || (row[column.key] || {}).value || null,
      });
    }, [row]);

    const InputComponent = column.columnContentType.timeOnly
      ? TimePicker
      : column.columnContentType.timeRequired
      ? DateTimePicker
      : DatePicker;

    return (
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          minWidth: 125,
          cursor:
            (row[column.key] || {}).cellEditable === false
              ? undefined
              : 'pointer',
        }}
      >
        <div
          style={{
            paddingTop: 3,
            cursor:
              (row[column.key] || {}).cellEditable === false
                ? undefined
                : 'pointer',
          }}
        >
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <InputComponent
              placeholder={(column || {}).title}
              minDate={new Date()}
              ref={timePickerRef}
              TextFieldComponent={TextField}
              format={
                column.columnContentType.timeRequired
                  ? 'DD/MM/YYYY hh:mm a'
                  : column.columnContentType.timeOnly
                  ? 'hh:mm a'
                  : 'DD/MM/YYYY'
              }
              disableUnderline
              InputProps={{
                disableUnderline: true,
                style: {
                  ...((row[column.key] || {}).value
                    ? { color: '#505050' }
                    : { color: '#545454' }),
                  fontSize: '1rem',
                  wordWrap: 'break-word',
                  whiteSpace: 'pre-wrap',
                },
              }}
              disabled={(row[column.key] || {}).cellEditable === false}
              value={
                (rowState || {})[column.key] || (row[column.key] || {}).value
                  ? moment.unix(
                      rowState[column.key] || (row[column.key] || {}).value
                    )
                  : null
              }
              onChange={(date) =>
                handleRowChange(row.id, { [column.key]: date.unix() })
              }
              autoOk
              fullWidth
              variant="inline"
              style={{
                color: '#747474',
              }}
            />
          </MuiPickersUtilsProvider>
        </div>
      </Box>
    );
  },
  (prevProps, currentProps) =>
    (prevProps.rowState || {})[(prevProps.column || {}).key] ===
      (currentProps.rowState || {})[(currentProps.column || {}).key] &&
    prevProps.delected === currentProps.selected
);

export default DateInputCell;
